import { observer } from 'mobx-react-lite'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { Image, StatusBar, View } from 'react-native'
import { useFocusEffect, useLocalSearchParams, useNavigation, useRouter } from 'expo-router'

import { MainHeader } from '../../components/MainHeader/MainHeader'
import { useStore } from '../../models'
import { GameModeTag } from '../../models/api-store'
import { startStyles } from './style'
import { DS } from '../../design-system'
import { translate } from '../../i18n'
import { scale } from '../../styles/sizes'
import { useSafeAreaInsets } from 'react-native-safe-area-context'
import { WebWrapper } from '@/components/WebWrapper'

export const JoinOpenTableScreen = observer(() => {
  const router = useRouter()
  const navigation = useNavigation()
  const isFocused = navigation.isFocused()

  type GameMode = Pick<typeof GameModeTag, 'tournament' | 'default'>
  const { gameMode } = useLocalSearchParams<{ gameMode: keyof GameMode }>()

  const store = useStore()
  const insets = useSafeAreaInsets()
  const [visible, setVisible] = useState(false)
  const players = useMemo(() => store.game.game?.players ?? [], [store.game.game?.players])

  const getPublicTournament = useCallback(async () => {
    try {
      await store.game.getActivePublicTournament()
    } catch (error) {
      console.log('Error in getting public tournament: ', error)
    }
  }, [store.game])

  const getOpenDefaultGame = useCallback(async () => {
    try {
      await store.game.getActiveOpenDefaultGame()
    } catch (error) {
      console.log('Erro in getting open default game: ', error)
    }
  }, [store.game])

  const onLeaveGame = useCallback(async () => {
    try {
      setVisible(true)
      store.game.setGameId('')
      store.communication.clearChannel()
      store.game.clearCurrentTournament()
      requestAnimationFrame(async () => {
        await store.game.leaveCurrentGame()
        setVisible(false)
        router.navigate('/(root)/(tabs)')
      })
    } catch (error) {
      console.error('onLeaveGame or Game Deleted', error)
    }
  }, [store.communication, store.game])

  useFocusEffect(
    useCallback(() => {
      if (gameMode === GameModeTag.tournament) {
        getPublicTournament()
      } else {
        getOpenDefaultGame()
      }
    }, [getOpenDefaultGame, getPublicTournament, gameMode])
  )

  useEffect(() => {
    let timeout: number

    if (isFocused && players.length > 0 && !visible) {
      timeout = setTimeout(() => {
        router.navigate('/game')
      }, 1000)
    } else if (visible) {
      onLeaveGame()
    }

    return () => {
      if (timeout) {
        clearInterval(timeout)
      }
    }
  }, [navigation, onLeaveGame, players.length, visible, isFocused])

  return (
    <View style={[startStyles.container, { paddingTop: insets.top }]}>
      <StatusBar animated barStyle="dark-content" />
      <WebWrapper>
        <MainHeader
          leftPress={() => setVisible(true)}
          headerContainerStyle={{
            backgroundColor: '#F6F2E9'
          }}
          titleStyle={{ color: '#000000', fontSize: 30 }}
          title=" "
        />
        <DS.Frame flex={1} justifyContent="center" alignItems="center" gap={'12'} style={startStyles.subContainer}>
          <Image
            source={require('../../../app/components/ANewDesign/assets/Chip-Animation-Clean.gif')}
            style={{ width: scale(48), height: scale(48) }}
          />
          <DS.Text variant="Heading 3/Regular" textAlign="center" style={{ fontSize: 24, letterSpacing: 1 }}>
            {translate('openTableScreen.landingScreenText')}
          </DS.Text>
        </DS.Frame>
      </WebWrapper>
    </View>
  )
})
